import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  GridView,
  Icon,
  Widget,
  Button,
  FormInput,
  FormItem,
  notification,
  CompositeView,
  Form,
  CrudContext,
  FormSubmitButton,
  FormatText,
  FormTextArea,
  MasterDetailForm,
  ButtonDelete,
  useRouter,
  FormSwitch,
  FormSelect,
  SimpleView,
} from '@digital/ui';
import { createTipoServico, updateTipoServico, deleteTipoServico, getAllTiposServico } from '../../api/tipoServico';
import { hasPermission } from '@app/helpers/permissions';
import { getContratoOptionExcetoEncerradosForSelect } from '@app/api/contrato';

const TipoServico = () => {
  const [GetAllItems, setGetAllItems] = useState(() => {
    return getAllTiposServico;
  });
  const [optionsContrato, setOptionsContrato] = useState([]);

  const { history } = useRouter();

  const onCreateTipoServico = (values: any) => {
    return createTipoServico(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => getAllTiposServico);
      }
      return resp;
    });
  };

  const onUpdateTipoServico = (values: any) => {
    return updateTipoServico(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => getAllTiposServico);
      }
      return resp;
    });
  };

  useEffect(() => {
    getContratoOptionExcetoEncerradosForSelect().then(data => setOptionsContrato(data));
  }, []);

  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      createItem={hasPermission(['TIPO_SERVICO_CADASTRAR']) ? onCreateTipoServico : undefined}
      updateItem={onUpdateTipoServico}
      icon="commons-settings"
      detailTitleExtractor={x => x.sigla + ' - ' + x.nome}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.sigla ? item.sigla.toLowerCase().startsWith(value.toLowerCase()) : false)
      }
      disableNotification
      titleExtractor={x => x.nome}
      descriptionExtractor={x => x.sigla || ''}>
      <CompositeView>
        <CrudContext.Consumer>
          {({ selectedItem }) => {
            return (
              <GridView noform>
                <MasterDetailForm
                  validationSchema={Yup.object().shape({
                    nome: Yup.string().required('Nome requerido').max(150, 'O nome deve ter no máximo 150 caracteres.'),
                    sigla: Yup.string().required('Sigla requerido').max(5, 'A sigla deve ter no máximo 5 caracteres.'),
                    descricao: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
                  })}>
                  <Widget
                    title="Tipo de Serviço"
                    actions={[
                      selectedItem && hasPermission(['TIPO_SERVICO_DELETAR']) && (
                        <ButtonDelete
                          icon={null}
                          type="danger"
                          confirm="Deseja realmente excluir este registro?"
                          okText="Confirmar"
                          onClick={() => {
                            deleteTipoServico(selectedItem.id).then(resp => {
                              if (resp.valid) {
                                setGetAllItems(() => Promise.resolve(undefined));
                                setGetAllItems(() => getAllTiposServico);
                                history.push('/tiposservicos');
                              }
                            });
                          }}
                        />
                      ),
                      hasPermission(['TIPO_SERVICO_CADASTRAR', 'TIPO_SERVICO_EDITAR']) && (
                        <FormSubmitButton noIcon={true} type="primary">
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                      ),
                    ]}>
                    <FormInput label="Nome" name="nome" span={4} />
                    <FormInput label="Sigla" name="sigla" span={4} />
                    <FormSwitch label="Serviço Exige Especificação?" name="exigeEspecificacao" span={4} />
                    <FormTextArea rows={4} label="Descrição" name="descricao" />
                    <FormSelect
                      options={optionsContrato}
                      showSearch
                      label="Número do Contrato"
                      name="contratoAcordoFornecimentoId"
                      span={4}
                      filterOption={(input, option) => {
                        return option.props.children.props.id.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                      }}
                    />
                  </Widget>
                </MasterDetailForm>
              </GridView>
            );
          }}
        </CrudContext.Consumer>
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default TipoServico;
